import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./ActivityFiles.module.css";
import { testUrl } from "../BaseData";

// Faoliyat turi sahifalari (masalan, Xalqaro aloqalar) ostidagi fayllar ro'yxati.
// Fayllar admin paneldan: Faoliyat turlari -> sahifa -> "Sahifa fayllari".

const LABELS = {
  uz: { title: "Fayllar", download: "Yuklab olish" },
  en: { title: "Files", download: "Download" },
  ru: { title: "Файлы", download: "Скачать" },
};

const formatSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const fileUrl = (path) => {
  if (!path) return "#";
  if (path.startsWith("http")) return path;
  return `${String(testUrl).replace(/\/$/, "")}${path.startsWith("/") ? "" : "/"}${path}`;
};

const ActivityFiles = ({ files, title }) => {
  const { i18n } = useTranslation();
  if (!files || files.length === 0) return null;

  const lang = (i18n.language || "uz").slice(0, 2);
  const T = LABELS[lang] || LABELS.uz;

  return (
    <section className={classes.wrap}>
      <h2 className={classes.title}>{(title && (title[lang] || title.uz)) || T.title}</h2>
      <ul className={classes.list}>
        {files.map((f) => {
          const title = f[`title_${lang}`] || f.title_uz || f.name;
          const meta = [f.ext && f.ext.toUpperCase(), formatSize(f.size)]
            .filter(Boolean)
            .join(" · ");
          return (
            <li key={f.id}>
              <a
                className={classes.item}
                href={fileUrl(f.url)}
                target="_blank"
                rel="noreferrer"
                download
              >
                <span className={classes.ext}>{(f.ext || "file").slice(0, 4)}</span>
                <span className={classes.body}>
                  <span className={classes.name}>{title}</span>
                  {meta && <span className={classes.meta}>{meta}</span>}
                </span>
                <span className={classes.action}>
                  {T.download}
                  <span aria-hidden="true"> ↓</span>
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ActivityFiles;
